import { createContext, useContext, useState, useEffect } from "react";
import api from "../api/api";
import { useSocket } from "../context/SocketProvider";

export const PortfolioContext = createContext();
export const usePortfolio = () => useContext(PortfolioContext);

export function PortfolioProvider({ children }) {
  const [portfolio, setPortfolio] = useState(null);
  const socket = useSocket();

  async function fetchPortfolio() {
    try {
      const response = await api.get("/user/financials");
      setPortfolio({
        available_balance: Number(response.data.available_balance),
        total_cost_basis: Number(response.data.total_cost_basis),
        total_portfolio_value: Number(response.data.total_portfolio_value),
        total_profit_loss: Number(response.data.total_profit_loss),
        total_return_percentage: Number(response.data.total_return_percentage),
        user_id: response.data.user_id
      });
    } catch (err) {
      console.error("Error fetching user financials:", err);
    }
  }

  useEffect(() => {
    fetchPortfolio();
  }, []);

  useEffect(() => {
    if (!socket) return;
    const handleUpdate = () => {
      fetchPortfolio();
    };
    socket.on('coinDataUpdated', handleUpdate);
    return () => {
      socket.off('coinDataUpdated', handleUpdate);
    };
  }, [socket]);

  return (
    <PortfolioContext.Provider value={{ portfolio, refresh: fetchPortfolio }}>
      {children}
    </PortfolioContext.Provider>
  );
}